module.exports = __webpack_public_path__ + "static/media/menu_scroll.0daac39c.jpg";